import React from 'react';

import { RRLogo } from '../../design/components';

export interface ShellProps {
  /** Left sidebar — rendered above 880px. */
  sidebar?: React.ReactNode;
  /** Optional right-aligned slot for the mobile header (e.g. sign-out). */
  mobileHeaderRight?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * App chrome wrapper.
 *  - ≥880px: two-column grid with the sidebar on the left.
 *  - <880px: sidebar hides; a thin sticky header shows the wordmark + an
 *    optional slot for sign-out (Phase E wires this).
 */
const Shell: React.FC<ShellProps> = ({ sidebar, mobileHeaderRight, children }) => (
  <div className="rr-shell">
    {sidebar}
    <main className="rr-shell-main">
      <header className="rr-shell-header">
        <a href="/" className="rr-shell-header-brand" aria-label="Recipe Rack home">
          <span style={{ width: 24, height: 24, display: 'inline-block' }}>
            <RRLogo shelf="mixed" size={24} />
          </span>
          <span className="rr-shell-header-name">Recipe Rack</span>
        </a>
        {mobileHeaderRight}
      </header>
      {children}
    </main>
  </div>
);

export default Shell;
